<div>
  <app-period-filter
    [title]="'Extratos consolidados disponíveis'"
    [subTitle]="'Selecione uma das opções disponíveis ou defina o período desejado.'"
    [showBadgeDate]="false"
    (rangeChange)="handleRange($event)"
  ></app-period-filter>

  <div class="table-content">
    <bfd-tab-menu
      [menus]="menu"
      [prefix]="'date'"
      (menusEmitter)="changePage($event)"
    ></bfd-tab-menu>

    <bfd-transaction-table [tableOrigin]="'consolidated-extracts'" [data]="mockTable"></bfd-transaction-table>
  </div>
</div>
